export const applicationTranslations = {
  "es": {
    "briefy.tooLong": "El mensaje supera los 2000 caracteres. Divídelo en mensajes más cortos; tu texto se conserva.",
    "briefy.unconfirmed": "No pude confirmar la respuesta. Tu texto se conserva. Si pediste guardar algo, revisa la herramienta antes de repetir para evitar duplicados.",
    "briefy.tooltipTitle": "¿Por qué Briefy?",
    "briefy.tooltipBrief": "resúmenes ejecutivos al instante",
    "briefy.tooltipFamily": "soy parte del maletín",
    "briefy.tooltipBriefly": "breve, rápido, sin fricción",
    "briefy.typing": "Escribiendo...",
    "briefy.startHint": "Pregúntame cómo usar cualquier herramienta",
    "briefy.confirmed": "Confirmado",
    "briefy.failed": "No completado",
    "briefy.pendingConfirmation": "Sin confirmar",
    "briefy.tool.lead": "Lead",
    "briefy.tool.customer": "Cliente",
    "briefy.tool.contact": "Contacto",
    "briefy.tool.task": "Tarea",
    "briefy.tool.appointment": "Cita",
    "briefy.tool.note": "Nota",
    "briefy.tool.priceIndex": "Análisis de precio",
    "briefy.tool.service": "Servicio",
    "pos.conceptService": "Servicio",
    "briefy.tool.serviceSale": "Venta de servicio",
    "briefy.tool.serviceReport": "Reporte de servicios",
    "briefy.tool.search": "Búsqueda",
    "briefy.tool.summary": "Resumen",
    "briefy.tool.recent": "Recientes",
    "briefy.exploreTools": "Explorar herramientas",
    "briefy.stopVoice": "Detener dictado",
    "briefy.startVoice": "Dictar por voz",
    "briefy.listening": "Escuchando... habla",
    "briefyIdle.g0": "¿Te puedo ayudar en algo?",
    "cajaTabs.services": "Servicios",
    "cajaTabs.cobros": "Cobros",
    "payrollTax.disclaimer": "Calculadora estimativa",
    "charts.exactValues": "Los valores exactos están disponibles en la tabla de datos.",
    "charts.viewData": "Ver datos del gráfico",
    "charts.period": "Período / concepto",
    "charts.noData": "No hay movimientos para mostrar en este período.",
    "followup.title": "Leads que necesitan seguimiento",
    "followup.daysHint": "más de",
    "followup.days": "días",
    "digest.daysShort": "días",
    "followup.aiDraftFor": "Seguimiento IA para",
    "design.formSubtitle.FollowUpAutomationPanel": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.LeadDetailModal": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.PropertyGeoSearch": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.BudgetPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.CajaRegistradoraPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.CashPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.ChatPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.CompaniesPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.CustomersPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.InventoryPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.PayrollPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.ServicesPage": "Revisa los detalles antes de guardar.",
    "design.formSubtitle.TasksPage": "Revisa los detalles antes de guardar.",
    "followup.generating": "La IA está redactando tu seguimiento...",
    "googleSetup.saved": "¡Listo! Tu experiencia quedó personalizada",
    "googleSetup.title": "¡Bienvenido a BRIEFCASE!",
    "googleSetup.subtitle": "Cuéntanos de tu negocio para personalizar tu experiencia.",
    "googleSetup.industryLabel": "¿Cuál es tu tipo de negocio?",
    "googleSetup.currencyLabel": "¿En qué moneda trabajas?",
    "googleSetup.skip": "Ahora no",
    "googleSetup.start": "Comenzar",
    "installBanner.title": "Instala BRIEFCASE en tu celular",
    "installBanner.subtitle": "Acceso directo, más rápido y a pantalla completa",
    "installBanner.how": "Ver cómo",
    "installBanner.install": "Instalar",
    "tutorial.welcome.title": "¡Bienvenido!",
    "tutorial.welcome.desc": "Tu sistema ERP todo-en-uno.",
    "tutorial.dashboard.title": "Inicio",
    "tutorial.dashboard.desc": "Resumen de ventas y estadísticas.",
    "tutorial.pos.title": "Punto de Venta",
    "tutorial.pos.desc": "Caja registradora fácil de usar.",
    "tutorial.inventory.title": "Inventario",
    "tutorial.inventory.desc": "Productos y códigos de barras.",
    "tutorial.realestate.title": "Propiedades y Gestión",
    "tutorial.realestate.desc": "Clientes, propiedades y E-Sign.",
    "tutorial.esign.title": "Firma electrónica",
    "tutorial.esign.desc": "Firma documentos donde quieras.",
    "tutorial.contacts.title": "Contactos",
    "tutorial.contacts.desc": "Importa desde Excel o celular.",
    "tutorial.finances.title": "Finanzas",
    "tutorial.finances.desc": "Control de ingresos y gastos.",
    "tutorial.complete.title": "¡Listo!",
    "tutorial.complete.desc": "¡Éxito en tu negocio!",
    "tutorial.start": "¡Empezar!",
    "nav.analysis": "Análisis Avanzado",
    "analysis.title": "Análisis Avanzado",
    "nav.leads": "Leads CRM",
    "nav.archive": "Archivador",
    "layout.hello": "Hola",
    "nav.searchModule": "Buscar módulo...",
    "nav.noResults": "Sin resultados",
    "briefy.aiAssistant": "Asistente de IA",
    "briefy.createClient": "Crear cliente",
    "briefy.registerSale": "Registrar venta",
    "common.expand": "Expandir menú",
    "common.collapse": "Colapsar menú",
    "briefy.closeLead": "Pídele a BRIEFY consejos para cerrar este lead",
    "common.city": "Ciudad",
    "workspace.loadError": "No pudimos cargar esta información",
    "workspace.loadErrorHint": "Revisa tu conexión y vuelve a intentar. Los datos pendientes de cargar no representan un saldo de cero.",
    "common.retry": "Reintentar",
    "digest.toastTitle": "Briefy — Tu día de hoy",
    "digest.appointments": "citas",
    "digest.tasks": "tareas",
    "digest.lowStock": "con stock bajo",
    "digest.more": "más",
    "digest.title": "Resumen de hoy",
    "digest.byBriefy": "Preparado por Briefy",
    "digest.appointmentsTitle": "Citas de hoy",
    "digest.noAppointments": "Sin citas para hoy",
    "digest.tasksTitle": "Tareas de hoy",
    "digest.noTasks": "Sin tareas pendientes hoy",
    "digest.stockTitle": "Stock bajo",
    "digest.noLowStock": "Inventario saludable",
    "digest.units": "uds",
    "digest.inactiveTitle": "Clientes sin regresar",
    "digest.noInactive": "Todos tus clientes están activos",
    "digest.waComeback": "¡Hola! Te extrañamos 😊 ¿Te gustaría agendar tu próxima visita?",
    "digest.draftMsg": "Pedir mensaje a BRIEFY",
    "onboarding.pickIndustryHint": "Elige un tipo de negocio para continuar",
    "analysis.comparative": "Comparativo",
    "analysis.profitability": "Rentabilidad",
    "analysis.projections": "Proyecciones",
    "analysis.subtitle": "Comparativo, rentabilidad y proyecciones financieras",
    "analysis.help": "Compara períodos, analiza la rentabilidad por producto y proyecta el futuro financiero del negocio. Cambia entre las tres vistas usando las pestañas.",
    "analysis.comparativeIntro": "Compara tus resultados entre períodos.",
    "analysis.profitabilityIntro": "Identifica los productos que aportan más a tu negocio.",
    "analysis.projectionsIntro": "Explora la evolución prevista de tus ingresos.",
    "appointments.noAppointments": "No hay citas",
    "design.formSubtitle.AppointmentsPage": "Prepara los datos de la cita y su horario.",
    "design.formSubtitle.BillsPage": "Organiza tus pagos, fechas y recordatorios.",
    "common.subtotal": "Subtotal",
    "design.removeItem": "Eliminar ítem",
    "briefy.hintCashflow": "Analizo tu flujo de caja y te aviso si tus gastos crecen más que tus ingresos.",
    "companies.noCompanies": "No hay empresas registradas",
    "common.selectAll": "Seleccionar todos",
    "design.formSubtitle.ContactsPage": "Organiza la información y el seguimiento de tus contactos.",
    "contacts.importMobile": "Importar desde Celular",
    "briefy.hintCustomers": "Pregúntame por tus clientes: puedo crear uno nuevo, agendar un seguimiento o redactar un mensaje.",
    "nav.prospects": "Prospectos",
    "customers.visits": "visitas",
    "briefy.aboutClient": "Hablar con BRIEFY sobre este cliente",
    "customers.history": "Historial del Cliente",
    "customers.totalSpent": "Total gastado",
    "customers.purchases": "Compras",
    "customers.noPurchases": "Sin compras registradas",
    "customers.items": "artículos",
    "customers.appointmentsLabel": "Citas",
    "customers.noAppointments": "Sin citas registradas",
    "briefy.hintInvoices": "Te ayudo a generar facturas y a recordarte cuáles siguen pendientes de pago.",
    "facturas.workspaceTitle": "Facturas",
    "facturas.workspaceSubtitle": "Crea facturas, digitaliza comprobantes y consulta tus documentos.",
    "invoices.newInvoice": "Nueva Factura",
    "common.previousMonth": "Mes anterior",
    "common.nextMonth": "Mes siguiente",
    "design.formSubtitle.FacturasPage": "Revisa los datos, conceptos e importes de tu factura.",
    "briefy.hintInventory": "¿Stock bajo? Puedo avisarte qué productos reponer y ayudarte a crear órdenes de compra.",
    "inventory.catalogVisible": "Visible en catálogo público",
    "notes.confirmDelete": "¿Borrar esta nota?",
    "notes.title": "Mis Notas",
    "notes.subtitle": "Notas de voz y dictados guardados por Briefy. Tu cuaderno inteligente.",
    "notes.searchPlaceholder": "Buscar en mis notas...",
    "notes.new": "Nueva nota",
    "notes.newTitle": "Nueva nota",
    "notes.tip": "Abre Briefy (botón flotante) y dile: \"Apunta esta lista\" o \"Anota estas cuentas\". Briefy escuchará, entenderá y guardará la nota aquí automáticamente.",
    "notes.emptyTitle": "Sin notas aún",
    "notes.empty": "Empieza dictándole a Briefy o crea una nota manualmente con el botón \"Nueva nota\".",
    "notes.unpin": "Desfijar",
    "notes.pin": "Fijar",
    "notes.dictated": "Dictado por Briefy",
    "notes.titlePlaceholder": "Título de la nota",
    "notes.contentPlaceholder": "Escribe o usa el micrófono para dictar...",
    "notes.stopDictation": "Detener",
    "notes.startDictation": "Dictar",
    "notes.tagsPlaceholder": "Etiquetas (separadas por coma)",
    "notes.listening": "Escuchando... habla con claridad. Toca el micrófono para detener.",
    "notes.editTitle": "Editar nota",
    "pos.cashIncomeInvalidAmount": "Por favor ingresa un monto válido",
    "pos.cashIncomeDefaultDesc": "Ingreso manual en efectivo",
    "pos.cashIncomeSaved": "Ingreso registrado correctamente",
    "pos.cashIncomeError": "Error al registrar el ingreso",
    "briefy.hintPos": "¿Necesitas ayuda con una venta? Pídeme agregar productos, aplicar descuentos o registrar el pago.",
    "pos.cashIncome": "Ingresos en Efectivo",
    "pos.closeCash": "Cerrar Caja",
    "common.clearSearch": "Limpiar búsqueda",
    "pos.emptyIndustryTitle": "Tu catálogo está vacío",
    "pos.emptyIndustryDesc": "Agrega los productos o servicios de tu negocio",
    "pos.goInventory": "Ir a Inventario",
    "pos.noCustomer": "Cliente ocasional (sin registrar)",
    "pos.cashIncomeSubtitle": "Registra ingresos manuales que no pasaron por la caja registradora (propinas, ventas externas, devoluciones de adelantos, etc.)",
    "pos.todayBalance": "Balance del Día",
    "pos.sales": "Ventas",
    "pos.income": "Ingresos",
    "pos.expenses": "Gastos",
    "pos.expectedCash": "Caja Esperada",
    "pos.preview": "(vista previa)",
    "pos.amount": "Monto",
    "pos.concept": "Concepto",
    "pos.conceptExtraSale": "Venta Extra (sin factura)",
    "pos.conceptTip": "Propina",
    "pos.conceptCommission": "Comisión",
    "pos.conceptRent": "Alquiler Cobrado",
    "pos.conceptRefund": "Reembolso Recibido",
    "pos.conceptOther": "Otros Ingresos",
    "pos.description": "Descripción",
    "pos.descriptionPlaceholder": "Detalles del ingreso (opcional)...",
    "briefy.hintPayroll": "Te ayudo a calcular pagos, deducciones y a preparar la nómina de tu equipo.",
    "clock.tabLabel": "Reloj Checador",
    "tasks.tabLabel": "Tareas",
    "ui.kioskPin": "PIN Reloj Checador",
    "ui.optional4digits": "4 dígitos, opcional",
    "ui.kioskPinHint": "El empleado usará este PIN para marcar entrada/salida en el Reloj Checador.",
    "pricing.subscribe": "Suscribirse",
    "briefy.hintPurchases": "¿Necesitas reabastecer? Te ayudo a crear órdenes para tus proveedores.",
    "design.formSubtitle.PurchasesPage": "Revisa el proveedor y los detalles de tu compra.",
    "design.formSubtitle.RealEstatePage": "Organiza los detalles de tus propiedades y clientes.",
    "design.formSubtitle.documents": "Guarda y organiza los documentos de este cliente.",
    "briefy.toggleBadge": "Asistente IA",
    "briefy.toggleDesc": "Tu asistente flotante con IA disponible en todas las herramientas. Responde preguntas, explica flujos y te guía paso a paso.",
    "settings.taxConfig": "Configuración de Impuestos",
    "settings.selectRegion": "Selecciona tu región",
    "settings.taxRatePct": "Tasa de impuesto (%)",
    "settings.taxNameLabel": "Nombre del impuesto",
    "settings.invoicePreview": "Vista previa en factura:",
    "settings.previewBase": "Sobre una venta de $100",
    "settings.accountInfo": "Información de cuenta",
    "settings.plan": "Plan",
    "settings.planBusiness": "Empresarial",
    "settings.planFree": "Gratuito",
    "settings.subSuccess": "¡Suscripción Exitosa!",
    "settings.subSuccessDesc": "Tu plan ha sido actualizado. Disfruta de todas las funciones.",
    "briefy.hintTasks": "Dime qué necesitas hacer y lo agrego a tu lista de tareas con recordatorio.",
    "briefy.hintTransport": "Pregúntame por mantenimientos, gastos o documentos de tus vehículos.",
    "ui.noData": "No hay datos",
    "design.formSubtitle.TransportPage": "Mantén al día tus vehículos y sus gastos.",
    "common.next": "Siguiente",
    "common.myBusiness": "Mi Negocio",
    "common.preview": "Vista Previa",
    "closing.alreadyClosed": "La caja de este día ya está cerrada",
    "closing.openingBalance": "Saldo inicial",
    "closing.totalSales": "Ventas totales",
    "closing.actualBalance": "Saldo real",
    "closing.difference": "Diferencia",
    "closing.closeDay": "Cerrar día",
    "closing.totalIncome": "Ingresos totales",
    "closing.totalExpenses": "Gastos totales",
    "closing.expectedBalance": "Saldo esperado",
    "closing.notes": "Notas",
    "banners.tools.AdminPage.title": "Panel de Administración",
    "banners.tools.AdminPage.subtitle": "Gestiona usuarios, planes y reseñas",
    "banners.tools.AdminRevenuePage.title": "Ingresos · Administración",
    "banners.tools.AdminRevenuePage.subtitle": "Suscripciones y comisiones de Briefcase Pay",
    "banners.tools.CobrosPage.title": "Cobros Electrónicos",
    "banners.tools.CobrosPage.subtitle": "Gestiona cobros con tarjeta y transferencias",
    "banners.tools.InventoryPage.subtitle": "Gestiona productos, existencias y códigos de barras",
    "banners.tools.ServicesPage.title": "Catálogo de Servicios",
    "banners.tools.ServicesPage.subtitle": "Organiza, factura y analiza los servicios de tu negocio"
  },
  "en": {
    "briefy.tooLong": "The message exceeds 2,000 characters. Split it into shorter messages; your text is preserved.",
    "briefy.unconfirmed": "I could not confirm the response. Your text is preserved. If you asked to save something, check the tool before retrying to avoid duplicates.",
    "briefy.confirmed": "Confirmed",
    "briefy.failed": "Not completed",
    "briefy.pendingConfirmation": "Unconfirmed",
    "briefy.tool.customer": "Client",
    "briefy.tool.contact": "Contact",
    "briefy.tool.note": "Note",
    "briefy.tool.priceIndex": "Price analysis",
    "briefy.tool.service": "Service",
    "pos.conceptService": "Service",
    "briefy.tool.serviceSale": "Service sale",
    "briefy.tool.serviceReport": "Services report",
    "briefy.exploreTools": "Explore tools",
    "briefy.stopVoice": "Stop dictation",
    "briefy.startVoice": "Dictate by voice",
    "briefy.listening": "Listening... speak now",
    "briefyIdle.g0": "Can I help you with anything?",
    "cajaTabs.services": "Services",
    "cajaTabs.cobros": "Collections",
    "payrollTax.disclaimer": "Estimate calculator",
    "charts.exactValues": "Exact values are available in the data table.",
    "charts.viewData": "View chart data",
    "charts.period": "Period / item",
    "charts.noData": "There are no transactions to show for this period.",
    "followup.title": "Leads needing follow-up",
    "followup.daysHint": "more than",
    "followup.days": "days",
    "digest.daysShort": "days",
    "followup.aiDraftFor": "AI follow-up for",
    "design.formSubtitle.FollowUpAutomationPanel": "Review the details before saving.",
    "design.formSubtitle.LeadDetailModal": "Review the details before saving.",
    "design.formSubtitle.PropertyGeoSearch": "Review the details before saving.",
    "design.formSubtitle.BudgetPage": "Review the details before saving.",
    "design.formSubtitle.CajaRegistradoraPage": "Review the details before saving.",
    "design.formSubtitle.CashPage": "Review the details before saving.",
    "design.formSubtitle.ChatPage": "Review the details before saving.",
    "design.formSubtitle.CompaniesPage": "Review the details before saving.",
    "design.formSubtitle.CustomersPage": "Review the details before saving.",
    "design.formSubtitle.InventoryPage": "Review the details before saving.",
    "design.formSubtitle.PayrollPage": "Review the details before saving.",
    "design.formSubtitle.ServicesPage": "Review the details before saving.",
    "design.formSubtitle.TasksPage": "Review the details before saving.",
    "followup.generating": "AI is drafting your follow-up...",
    "googleSetup.saved": "Done! Your experience is now personalized",
    "googleSetup.title": "Welcome to BRIEFCASE!",
    "googleSetup.subtitle": "Tell us about your business to personalize your experience.",
    "googleSetup.industryLabel": "What type of business do you run?",
    "googleSetup.currencyLabel": "Which currency do you use?",
    "googleSetup.skip": "Not now",
    "googleSetup.start": "Get started",
    "installBanner.title": "Install BRIEFCASE on your phone",
    "installBanner.subtitle": "Direct access, faster and full screen",
    "installBanner.how": "See how",
    "installBanner.install": "Install",
    "tutorial.welcome.title": "Welcome!",
    "tutorial.welcome.desc": "Your all-in-one ERP system.",
    "tutorial.dashboard.title": "Dashboard",
    "tutorial.dashboard.desc": "Sales summary and statistics.",
    "tutorial.pos.title": "Point of Sale",
    "tutorial.pos.desc": "Easy-to-use cash register.",
    "tutorial.inventory.title": "Inventory",
    "tutorial.inventory.desc": "Products and barcodes.",
    "tutorial.realestate.title": "Properties & Management",
    "tutorial.realestate.desc": "Customers, properties and e-signatures.",
    "tutorial.esign.title": "E-signature",
    "tutorial.esign.desc": "Sign documents wherever you are.",
    "tutorial.contacts.title": "Contacts",
    "tutorial.contacts.desc": "Import from Excel or your phone.",
    "tutorial.finances.title": "Finances",
    "tutorial.finances.desc": "Track income and expenses.",
    "tutorial.complete.title": "Done!",
    "tutorial.complete.desc": "Wishing your business success!",
    "tutorial.start": "Start!",
    "nav.analysis": "Advanced analysis",
    "analysis.title": "Advanced analysis",
    "nav.leads": "CRM Leads",
    "nav.archive": "Digital archive",
    "layout.hello": "Hello",
    "nav.searchModule": "Search modules...",
    "nav.noResults": "No results",
    "briefy.aiAssistant": "AI assistant",
    "briefy.createClient": "Create customer",
    "briefy.registerSale": "Register sale",
    "common.expand": "Expand menu",
    "common.collapse": "Collapse menu",
    "briefy.closeLead": "Ask BRIEFY for tips on closing this lead",
    "common.city": "City",
    "workspace.loadError": "We could not load this information",
    "workspace.loadErrorHint": "Check your connection and try again. Data that has not loaded does not mean a zero balance.",
    "common.retry": "Retry",
    "digest.toastTitle": "Briefy — Your day today",
    "digest.appointments": "appointments",
    "digest.tasks": "tasks",
    "digest.lowStock": "with low stock",
    "digest.more": "more",
    "digest.title": "Today’s summary",
    "digest.byBriefy": "Prepared by Briefy",
    "digest.appointmentsTitle": "Today’s appointments",
    "digest.noAppointments": "No appointments today",
    "digest.tasksTitle": "Today’s tasks",
    "digest.noTasks": "No pending tasks today",
    "digest.stockTitle": "Low stock",
    "digest.noLowStock": "Inventory is healthy",
    "digest.units": "units",
    "digest.inactiveTitle": "Customers who have not returned",
    "digest.noInactive": "All your customers are active",
    "digest.waComeback": "Hi! We miss you 😊 Would you like to schedule your next visit?",
    "digest.draftMsg": "Ask BRIEFY to draft a message",
    "onboarding.pickIndustryHint": "Choose a business type to continue",
    "analysis.comparative": "Comparative",
    "analysis.profitability": "Profitability",
    "analysis.projections": "Projections",
    "analysis.subtitle": "Comparisons, profitability and financial projections",
    "analysis.help": "Compare periods, analyze profitability by product and project your business finances. Switch between the three views using the tabs.",
    "analysis.comparativeIntro": "Compare your results across periods.",
    "analysis.profitabilityIntro": "Identify the products contributing most to your business.",
    "analysis.projectionsIntro": "Explore the projected trend in your income.",
    "appointments.noAppointments": "No appointments",
    "design.formSubtitle.AppointmentsPage": "Prepare the appointment details and schedule.",
    "design.formSubtitle.BillsPage": "Organize your payments, dates and reminders.",
    "common.subtotal": "Subtotal",
    "design.removeItem": "Remove item",
    "briefy.hintCashflow": "I analyze your cash flow and alert you if expenses grow faster than income.",
    "companies.noCompanies": "No companies registered",
    "common.selectAll": "Select all",
    "design.formSubtitle.ContactsPage": "Organize your contacts’ information and follow-up.",
    "contacts.importMobile": "Import from Phone",
    "briefy.hintCustomers": "Ask me about your customers: I can create a new one, schedule a follow-up or draft a message.",
    "nav.prospects": "Prospects",
    "customers.visits": "visits",
    "briefy.aboutClient": "Talk to BRIEFY about this customer",
    "customers.history": "Customer history",
    "customers.totalSpent": "Total spent",
    "customers.purchases": "Purchases",
    "customers.noPurchases": "No purchases recorded",
    "customers.items": "items",
    "customers.appointmentsLabel": "Appointments",
    "customers.noAppointments": "No appointments recorded",
    "briefy.hintInvoices": "I help you create invoices and remember which ones remain unpaid.",
    "facturas.workspaceTitle": "Invoices",
    "facturas.workspaceSubtitle": "Create invoices, digitize receipts and view your documents.",
    "invoices.newInvoice": "New invoice",
    "common.previousMonth": "Previous month",
    "common.nextMonth": "Next month",
    "design.formSubtitle.FacturasPage": "Review your invoice details, items and amounts.",
    "briefy.hintInventory": "Low stock? I can tell you which products to replenish and help you create purchase orders.",
    "inventory.catalogVisible": "Visible in the public catalog",
    "notes.confirmDelete": "Delete this note?",
    "notes.title": "My Notes",
    "notes.subtitle": "Voice notes and dictations saved by Briefy. Your smart notebook.",
    "notes.searchPlaceholder": "Search my notes...",
    "notes.new": "New note",
    "notes.newTitle": "New note",
    "notes.tip": "Open Briefy using the floating button and ask it to note a list or some figures. Briefy can save your note here.",
    "notes.emptyTitle": "No notes yet",
    "notes.empty": "Start dictating to Briefy or create a note manually with the New note button.",
    "notes.unpin": "Unpin",
    "notes.pin": "Pin",
    "notes.dictated": "Dictated by Briefy",
    "notes.titlePlaceholder": "Note title",
    "notes.contentPlaceholder": "Type or use the microphone to dictate...",
    "notes.stopDictation": "Stop",
    "notes.startDictation": "Dictate",
    "notes.tagsPlaceholder": "Tags (comma-separated)",
    "notes.listening": "Listening... speak clearly. Tap the microphone to stop.",
    "notes.editTitle": "Edit note",
    "pos.cashIncomeInvalidAmount": "Please enter a valid amount",
    "pos.cashIncomeDefaultDesc": "Manual cash income",
    "pos.cashIncomeSaved": "Income recorded successfully",
    "pos.cashIncomeError": "Could not record the income",
    "briefy.hintPos": "Need help with a sale? Ask me to add products, apply discounts or record the payment.",
    "pos.cashIncome": "Cash Income",
    "pos.closeCash": "Close register",
    "common.clearSearch": "Clear search",
    "pos.emptyIndustryTitle": "Your catalog is empty",
    "pos.emptyIndustryDesc": "Add your business products or services",
    "pos.goInventory": "Go to inventory",
    "pos.noCustomer": "Walk-in customer (not registered)",
    "pos.cashIncomeSubtitle": "Record manual income outside the cash register, such as tips, external sales or returned advances.",
    "pos.todayBalance": "Daily balance",
    "pos.sales": "Sales",
    "pos.income": "Earnings",
    "pos.expenses": "Expenses",
    "pos.expectedCash": "Expected cash",
    "pos.preview": "(preview)",
    "pos.amount": "Amount",
    "pos.concept": "Category",
    "pos.conceptExtraSale": "Extra sale (without invoice)",
    "pos.conceptTip": "Tip",
    "pos.conceptCommission": "Commission",
    "pos.conceptRent": "Rent received",
    "pos.conceptRefund": "Refund received",
    "pos.conceptOther": "Other income",
    "pos.description": "Description",
    "pos.descriptionPlaceholder": "Income details (optional)...",
    "briefy.hintPayroll": "I help you calculate pay and deductions and prepare your team’s payroll.",
    "clock.tabLabel": "Time clock",
    "tasks.tabLabel": "Tasks",
    "ui.kioskPin": "Time clock PIN",
    "ui.optional4digits": "4 digits, optional",
    "ui.kioskPinHint": "The employee will use this PIN to clock in and out.",
    "pricing.subscribe": "Subscribe",
    "briefy.hintPurchases": "Need to restock? I help you create orders for your suppliers.",
    "design.formSubtitle.PurchasesPage": "Review the supplier and purchase details.",
    "design.formSubtitle.RealEstatePage": "Organize your property and customer details.",
    "design.formSubtitle.documents": "Save and organize this customer’s documents.",
    "settings.taxConfig": "Tax settings",
    "settings.selectRegion": "Select your region",
    "settings.taxRatePct": "Tax rate (%)",
    "settings.taxNameLabel": "Tax name",
    "settings.invoicePreview": "Invoice preview:",
    "settings.previewBase": "On a $100 sale",
    "settings.accountInfo": "Account information",
    "settings.plan": "Plan",
    "settings.planBusiness": "Business",
    "settings.planFree": "Free",
    "settings.subSuccess": "Subscription successful!",
    "settings.subSuccessDesc": "Your plan has been updated. Enjoy all the features.",
    "briefy.hintTasks": "Tell me what you need to do and I will add it to your task list with a reminder.",
    "briefy.hintTransport": "Ask me about maintenance, expenses or documents for your vehicles.",
    "ui.noData": "No data",
    "design.formSubtitle.TransportPage": "Keep your vehicles and expenses up to date.",
    "common.next": "Next",
    "common.myBusiness": "My business",
    "common.preview": "Preview",
    "closing.alreadyClosed": "This day’s register is already closed",
    "closing.openingBalance": "Opening balance",
    "closing.totalSales": "Total sales",
    "closing.actualBalance": "Actual balance",
    "closing.difference": "Difference",
    "closing.closeDay": "Close day",
    "closing.totalIncome": "Total income",
    "closing.totalExpenses": "Total expenses",
    "closing.expectedBalance": "Expected balance",
    "closing.notes": "Notes",
    "banners.tools.AdminPage.title": "Administration",
    "banners.tools.AdminPage.subtitle": "Manage users, plans and reviews",
    "banners.tools.AdminRevenuePage.title": "Revenue · Administration",
    "banners.tools.AdminRevenuePage.subtitle": "Subscriptions and Briefcase Pay commissions",
    "banners.tools.CobrosPage.title": "Electronic Payments",
    "banners.tools.CobrosPage.subtitle": "Manage card payments and transfers",
    "banners.tools.InventoryPage.subtitle": "Manage products, stock and barcodes",
    "banners.tools.ServicesPage.title": "Service Catalog",
    "banners.tools.ServicesPage.subtitle": "Organize, invoice and analyze your business services"
  },
  "pt": {
    "briefy.tooLong": "A mensagem excede 2.000 caracteres. Divida-a em mensagens menores; seu texto foi preservado.",
    "briefy.unconfirmed": "Não foi possível confirmar a resposta. Seu texto foi preservado. Se pediu para salvar algo, verifique a ferramenta antes de tentar novamente para evitar duplicatas.",
    "briefy.confirmed": "Confirmado",
    "briefy.failed": "Não concluído",
    "briefy.pendingConfirmation": "Não confirmado",
    "briefy.tool.customer": "Cliente",
    "briefy.tool.contact": "Contato",
    "briefy.tool.note": "Nota",
    "briefy.tool.priceIndex": "Análise de preço",
    "briefy.tool.service": "Serviço",
    "pos.conceptService": "Serviço",
    "briefy.tool.serviceSale": "Venda de serviço",
    "briefy.tool.serviceReport": "Relatório de serviços",
    "briefy.exploreTools": "Explorar ferramentas",
    "briefy.stopVoice": "Parar ditado",
    "briefy.startVoice": "Ditar por voz",
    "briefy.listening": "Ouvindo... pode falar",
    "briefyIdle.g0": "Posso ajudar em algo?",
    "cajaTabs.services": "Servicos",
    "cajaTabs.cobros": "Recebimentos",
    "payrollTax.disclaimer": "Calculadora de estimativas",
    "charts.exactValues": "Os valores exatos estão disponíveis na tabela de dados.",
    "charts.viewData": "Ver dados do gráfico",
    "charts.period": "Período / item",
    "charts.noData": "Não há movimentações para exibir neste período.",
    "followup.title": "Leads que precisam de acompanhamento",
    "followup.daysHint": "mais de",
    "followup.days": "dias",
    "digest.daysShort": "dias",
    "followup.aiDraftFor": "Acompanhamento com IA para",
    "design.formSubtitle.FollowUpAutomationPanel": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.LeadDetailModal": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.PropertyGeoSearch": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.BudgetPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.CajaRegistradoraPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.CashPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.ChatPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.CompaniesPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.CustomersPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.InventoryPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.PayrollPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.ServicesPage": "Revise os detalhes antes de salvar.",
    "design.formSubtitle.TasksPage": "Revise os detalhes antes de salvar.",
    "followup.generating": "A IA está redigindo seu acompanhamento...",
    "googleSetup.saved": "Pronto! Sua experiência foi personalizada",
    "googleSetup.title": "Bem-vindo ao BRIEFCASE!",
    "googleSetup.subtitle": "Conte-nos sobre seu negócio para personalizar sua experiência.",
    "googleSetup.industryLabel": "Qual é o tipo do seu negócio?",
    "googleSetup.currencyLabel": "Em qual moeda você trabalha?",
    "googleSetup.skip": "Agora não",
    "googleSetup.start": "Começar",
    "installBanner.title": "Instale o BRIEFCASE no seu celular",
    "installBanner.subtitle": "Acesso direto, mais rápido e em tela cheia",
    "installBanner.how": "Veja como",
    "installBanner.install": "Instalar",
    "tutorial.welcome.title": "Bem-vindo!",
    "tutorial.welcome.desc": "Seu sistema ERP completo.",
    "tutorial.dashboard.title": "Painel",
    "tutorial.dashboard.desc": "Resumo de vendas e estatísticas.",
    "tutorial.pos.title": "Ponto de Venda",
    "tutorial.pos.desc": "Caixa registradora fácil de usar.",
    "tutorial.inventory.title": "Inventário",
    "tutorial.inventory.desc": "Produtos e códigos de barras.",
    "tutorial.realestate.title": "Imóveis e Gestão",
    "tutorial.realestate.desc": "Clientes, imóveis e assinaturas eletrônicas.",
    "tutorial.esign.title": "Assinatura eletrônica",
    "tutorial.esign.desc": "Assine documentos de onde estiver.",
    "tutorial.contacts.title": "Contatos",
    "tutorial.contacts.desc": "Importe do Excel ou do celular.",
    "tutorial.finances.title": "Financas",
    "tutorial.finances.desc": "Controle receitas e despesas.",
    "tutorial.complete.title": "Pronto!",
    "tutorial.complete.desc": "Sucesso para seu negócio!",
    "tutorial.start": "Começar!",
    "nav.analysis": "Análise avançada",
    "analysis.title": "Análise avançada",
    "nav.leads": "CRM Leads",
    "nav.archive": "Arquivo digital",
    "layout.hello": "Olá",
    "nav.searchModule": "Buscar módulos...",
    "nav.noResults": "Sem resultados",
    "briefy.aiAssistant": "Assistente de IA",
    "briefy.createClient": "Criar cliente",
    "briefy.registerSale": "Registrar venda",
    "common.expand": "Expandir menu",
    "common.collapse": "Recolher menu",
    "briefy.closeLead": "Peça ao BRIEFY dicas para converter este lead",
    "common.city": "Cidade",
    "workspace.loadError": "Não foi possível carregar estas informações",
    "workspace.loadErrorHint": "Verifique sua conexão e tente novamente. Dados não carregados não significam saldo zero.",
    "common.retry": "Tentar novamente",
    "digest.toastTitle": "Briefy — Seu dia de hoje",
    "digest.appointments": "compromissos",
    "digest.tasks": "tarefas",
    "digest.lowStock": "com estoque baixo",
    "digest.more": "mais",
    "digest.title": "Resumo de hoje",
    "digest.byBriefy": "Preparado por Briefy",
    "digest.appointmentsTitle": "Compromissos de hoje",
    "digest.noAppointments": "Sem compromissos para hoje",
    "digest.tasksTitle": "Tarefas de hoje",
    "digest.noTasks": "Sem tarefas pendentes hoje",
    "digest.stockTitle": "Estoque baixo",
    "digest.noLowStock": "Estoque saudável",
    "digest.units": "unid.",
    "digest.inactiveTitle": "Clientes que não retornaram",
    "digest.noInactive": "Todos os seus clientes estão ativos",
    "digest.waComeback": "Olá! Sentimos sua falta 😊 Gostaria de agendar sua próxima visita?",
    "digest.draftMsg": "Pedir ao BRIEFY uma mensagem",
    "onboarding.pickIndustryHint": "Escolha um tipo de negócio para continuar",
    "analysis.comparative": "Comparativo",
    "analysis.profitability": "Rentabilidade",
    "analysis.projections": "Projecoes",
    "analysis.subtitle": "Comparações, rentabilidade e projeções financeiras",
    "analysis.help": "Compare períodos, analise a rentabilidade por produto e projete as finanças do negócio. Alterne entre as três visualizações pelas abas.",
    "analysis.comparativeIntro": "Compare seus resultados entre períodos.",
    "analysis.profitabilityIntro": "Identifique os produtos que mais contribuem para seu negócio.",
    "analysis.projectionsIntro": "Explore a evolução prevista das suas receitas.",
    "appointments.noAppointments": "Sem compromissos",
    "design.formSubtitle.AppointmentsPage": "Prepare os dados e o horário do compromisso.",
    "design.formSubtitle.BillsPage": "Organize seus pagamentos, datas e lembretes.",
    "common.subtotal": "Subtotal",
    "design.removeItem": "Remover item",
    "briefy.hintCashflow": "Analiso seu fluxo de caixa e aviso se as despesas crescerem mais que as receitas.",
    "companies.noCompanies": "Sem empresas cadastradas",
    "common.selectAll": "Selecionar todos",
    "design.formSubtitle.ContactsPage": "Organize as informações e o acompanhamento dos seus contatos.",
    "contacts.importMobile": "Importar do Celular",
    "briefy.hintCustomers": "Pergunte sobre seus clientes: posso criar um novo, agendar um acompanhamento ou redigir uma mensagem.",
    "nav.prospects": "Prospectos",
    "customers.visits": "visitas",
    "briefy.aboutClient": "Falar com BRIEFY sobre este cliente",
    "customers.history": "Histórico do cliente",
    "customers.totalSpent": "Total gasto",
    "customers.purchases": "Compras",
    "customers.noPurchases": "Nenhuma compra registrada",
    "customers.items": "itens",
    "customers.appointmentsLabel": "Compromissos",
    "customers.noAppointments": "Nenhum compromisso registrado",
    "briefy.hintInvoices": "Ajudo a criar faturas e lembrar quais continuam pendentes de pagamento.",
    "facturas.workspaceTitle": "Faturas",
    "facturas.workspaceSubtitle": "Crie faturas, digitalize comprovantes e consulte seus documentos.",
    "invoices.newInvoice": "Nova fatura",
    "common.previousMonth": "Mês anterior",
    "common.nextMonth": "Próximo mês",
    "design.formSubtitle.FacturasPage": "Revise os dados, itens e valores da sua fatura.",
    "briefy.hintInventory": "Estoque baixo? Posso indicar quais produtos repor e ajudar a criar pedidos de compra.",
    "inventory.catalogVisible": "Visível no catálogo público",
    "notes.confirmDelete": "Excluir esta nota?",
    "notes.title": "Minhas Notas",
    "notes.subtitle": "Notas de voz e ditados salvos pelo Briefy. Seu caderno inteligente.",
    "notes.searchPlaceholder": "Buscar nas minhas notas...",
    "notes.new": "Nova nota",
    "notes.newTitle": "Nova nota",
    "notes.tip": "Abra o Briefy pelo botão flutuante e peça para anotar uma lista ou alguns valores. O Briefy pode salvar a nota aqui.",
    "notes.emptyTitle": "Nenhuma nota ainda",
    "notes.empty": "Comece ditando ao Briefy ou crie uma nota manualmente com o botão Nova nota.",
    "notes.unpin": "Desafixar",
    "notes.pin": "Fixar",
    "notes.dictated": "Ditado pelo Briefy",
    "notes.titlePlaceholder": "Título da nota",
    "notes.contentPlaceholder": "Digite ou use o microfone para ditar...",
    "notes.stopDictation": "Parar",
    "notes.startDictation": "Ditar",
    "notes.tagsPlaceholder": "Etiquetas (separadas por vírgula)",
    "notes.listening": "Ouvindo... fale com clareza. Toque no microfone para parar.",
    "notes.editTitle": "Editar nota",
    "pos.cashIncomeInvalidAmount": "Insira um valor válido",
    "pos.cashIncomeDefaultDesc": "Receita manual em dinheiro",
    "pos.cashIncomeSaved": "Receita registrada com sucesso",
    "pos.cashIncomeError": "Não foi possível registrar a receita",
    "briefy.hintPos": "Precisa de ajuda com uma venda? Peça para adicionar produtos, aplicar descontos ou registrar o pagamento.",
    "pos.cashIncome": "Receitas em Dinheiro",
    "pos.closeCash": "Fechar caixa",
    "common.clearSearch": "Limpar busca",
    "pos.emptyIndustryTitle": "Seu catálogo está vazio",
    "pos.emptyIndustryDesc": "Adicione os produtos ou serviços do seu negócio",
    "pos.goInventory": "Ir ao estoque",
    "pos.noCustomer": "Cliente avulso (não cadastrado)",
    "pos.cashIncomeSubtitle": "Registre receitas manuais fora do caixa, como gorjetas, vendas externas ou devoluções de adiantamentos.",
    "pos.todayBalance": "Saldo do dia",
    "pos.sales": "Vendas",
    "pos.income": "Rendimentos",
    "pos.expenses": "Despesas",
    "pos.expectedCash": "Caixa esperado",
    "pos.preview": "(prévia)",
    "pos.amount": "Valor",
    "pos.concept": "Categoria",
    "pos.conceptExtraSale": "Venda extra (sem fatura)",
    "pos.conceptTip": "Gorjeta",
    "pos.conceptCommission": "Comissão",
    "pos.conceptRent": "Aluguel recebido",
    "pos.conceptRefund": "Reembolso recebido",
    "pos.conceptOther": "Outras receitas",
    "pos.description": "Descrição",
    "pos.descriptionPlaceholder": "Detalhes da receita (opcional)...",
    "briefy.hintPayroll": "Ajudo a calcular pagamentos e deduções e preparar a folha da sua equipe.",
    "clock.tabLabel": "Relógio de ponto",
    "tasks.tabLabel": "Tarefas",
    "ui.kioskPin": "PIN do relógio de ponto",
    "ui.optional4digits": "4 dígitos, opcional",
    "ui.kioskPinHint": "O funcionário usará este PIN para registrar entrada e saída.",
    "pricing.subscribe": "Assinar",
    "briefy.hintPurchases": "Precisa repor o estoque? Ajudo a criar pedidos para seus fornecedores.",
    "design.formSubtitle.PurchasesPage": "Revise o fornecedor e os detalhes da compra.",
    "design.formSubtitle.RealEstatePage": "Organize os detalhes dos seus imóveis e clientes.",
    "design.formSubtitle.documents": "Salve e organize os documentos deste cliente.",
    "settings.taxConfig": "Configurações de impostos",
    "settings.selectRegion": "Selecione sua região",
    "settings.taxRatePct": "Alíquota de imposto (%)",
    "settings.taxNameLabel": "Nome do imposto",
    "settings.invoicePreview": "Prévia da fatura:",
    "settings.previewBase": "Em uma venda de $100",
    "settings.accountInfo": "Informações da conta",
    "settings.plan": "Plano",
    "settings.planBusiness": "Empresarial",
    "settings.planFree": "Gratuito",
    "settings.subSuccess": "Assinatura realizada!",
    "settings.subSuccessDesc": "Seu plano foi atualizado. Aproveite todos os recursos.",
    "briefy.hintTasks": "Diga o que precisa fazer e adicionarei à sua lista de tarefas com lembrete.",
    "briefy.hintTransport": "Pergunte sobre manutenção, despesas ou documentos dos seus veículos.",
    "ui.noData": "Sem dados",
    "design.formSubtitle.TransportPage": "Mantenha seus veículos e despesas em dia.",
    "common.next": "Próximo",
    "common.myBusiness": "Meu negócio",
    "common.preview": "Prévia",
    "closing.alreadyClosed": "O caixa deste dia já está fechado",
    "closing.openingBalance": "Saldo inicial",
    "closing.totalSales": "Vendas totais",
    "closing.actualBalance": "Saldo real",
    "closing.difference": "Diferença",
    "closing.closeDay": "Fechar dia",
    "closing.totalIncome": "Receitas totais",
    "closing.totalExpenses": "Despesas totais",
    "closing.expectedBalance": "Saldo esperado",
    "closing.notes": "Notas",
    "banners.tools.AdminPage.title": "Administração",
    "banners.tools.AdminPage.subtitle": "Gerencie usuários, planos e avaliações",
    "banners.tools.AdminRevenuePage.title": "Receitas · Administração",
    "banners.tools.AdminRevenuePage.subtitle": "Assinaturas e comissões do Briefcase Pay",
    "banners.tools.CobrosPage.title": "Pagamentos Eletrônicos",
    "banners.tools.CobrosPage.subtitle": "Gerencie pagamentos com cartão e transferências",
    "banners.tools.InventoryPage.subtitle": "Gerencie produtos, estoque e códigos de barras",
    "banners.tools.ServicesPage.title": "Catálogo de Serviços",
    "banners.tools.ServicesPage.subtitle": "Organize, fature e analise os serviços do seu negócio"
  },
  "fr": {
    "briefy.tooLong": "Le message dépasse 2 000 caractères. Divisez-le en messages plus courts ; votre texte est conservé.",
    "briefy.unconfirmed": "La réponse n’a pas pu être confirmée. Votre texte est conservé. Si vous avez demandé un enregistrement, vérifiez l’outil avant de réessayer pour éviter les doublons.",
    "briefy.confirmed": "Confirmé",
    "briefy.failed": "Non terminé",
    "briefy.pendingConfirmation": "Non confirmé",
    "briefy.tool.customer": "Client",
    "briefy.tool.contact": "Contact",
    "briefy.tool.note": "Note",
    "briefy.tool.priceIndex": "Analyse de prix",
    "briefy.tool.service": "Service",
    "pos.conceptService": "Service",
    "briefy.tool.serviceSale": "Vente de service",
    "briefy.tool.serviceReport": "Rapport de services",
    "briefy.exploreTools": "Explorer les outils",
    "briefy.stopVoice": "Arrêter la dictée",
    "briefy.startVoice": "Dicter à voix haute",
    "briefy.listening": "À l’écoute... parlez",
    "briefyIdle.g0": "Puis-je vous aider ?",
    "cajaTabs.services": "Services",
    "cajaTabs.cobros": "Encaissements",
    "payrollTax.disclaimer": "Calculateur estimatif",
    "charts.exactValues": "Les valeurs exactes sont disponibles dans le tableau de données.",
    "charts.viewData": "Voir les données du graphique",
    "charts.period": "Période / élément",
    "charts.noData": "Aucune opération à afficher pour cette période.",
    "followup.title": "Prospects à relancer",
    "followup.daysHint": "plus de",
    "followup.days": "jours",
    "digest.daysShort": "jours",
    "followup.aiDraftFor": "Relance par IA pour",
    "design.formSubtitle.FollowUpAutomationPanel": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.LeadDetailModal": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.PropertyGeoSearch": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.BudgetPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.CajaRegistradoraPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.CashPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.ChatPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.CompaniesPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.CustomersPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.InventoryPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.PayrollPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.ServicesPage": "Vérifiez les détails avant d’enregistrer.",
    "design.formSubtitle.TasksPage": "Vérifiez les détails avant d’enregistrer.",
    "followup.generating": "L’IA rédige votre relance...",
    "googleSetup.saved": "Terminé ! Votre expérience est personnalisée",
    "googleSetup.title": "Bienvenue sur BRIEFCASE !",
    "googleSetup.subtitle": "Parlez-nous de votre entreprise pour personnaliser votre expérience.",
    "googleSetup.industryLabel": "Quel est votre type d'entreprise ?",
    "googleSetup.currencyLabel": "Quelle devise utilisez-vous ?",
    "googleSetup.skip": "Pas maintenant",
    "googleSetup.start": "Commencer",
    "installBanner.title": "Installez BRIEFCASE sur votre téléphone",
    "installBanner.subtitle": "Accès direct, plus rapide et en plein écran",
    "installBanner.how": "Voir comment",
    "installBanner.install": "Installer",
    "tutorial.welcome.title": "Bienvenue !",
    "tutorial.welcome.desc": "Votre système ERP tout-en-un.",
    "tutorial.dashboard.title": "Tableau de bord",
    "tutorial.dashboard.desc": "Résumé des ventes et statistiques.",
    "tutorial.pos.title": "Point de Vente",
    "tutorial.pos.desc": "Caisse enregistreuse facile à utiliser.",
    "tutorial.inventory.title": "Inventaire",
    "tutorial.inventory.desc": "Produits et codes-barres.",
    "tutorial.realestate.title": "Biens et Gestion",
    "tutorial.realestate.desc": "Clients, biens et signatures électroniques.",
    "tutorial.esign.title": "Signature électronique",
    "tutorial.esign.desc": "Signez vos documents où que vous soyez.",
    "tutorial.contacts.title": "Contacts",
    "tutorial.contacts.desc": "Importez depuis Excel ou votre téléphone.",
    "tutorial.finances.title": "Finances",
    "tutorial.finances.desc": "Suivez vos revenus et dépenses.",
    "tutorial.complete.title": "Terminé !",
    "tutorial.complete.desc": "Bonne réussite à votre entreprise !",
    "tutorial.start": "Commencer !",
    "nav.analysis": "Analyse avancée",
    "analysis.title": "Analyse avancée",
    "nav.leads": "CRM Leads",
    "nav.archive": "Archives numériques",
    "layout.hello": "Bonjour",
    "nav.searchModule": "Rechercher un module...",
    "nav.noResults": "Aucun résultat",
    "briefy.aiAssistant": "Assistant IA",
    "briefy.createClient": "Créer un client",
    "briefy.registerSale": "Enregistrer la vente",
    "common.expand": "Développer le menu",
    "common.collapse": "Réduire le menu",
    "briefy.closeLead": "Demandez à BRIEFY des conseils pour convertir ce prospect",
    "common.city": "Ville",
    "workspace.loadError": "Impossible de charger ces informations",
    "workspace.loadErrorHint": "Vérifiez votre connexion et réessayez. Des données non chargées ne signifient pas un solde nul.",
    "common.retry": "Réessayer",
    "digest.toastTitle": "Briefy — Votre journée",
    "digest.appointments": "rendez-vous",
    "digest.tasks": "tâches",
    "digest.lowStock": "avec un stock faible",
    "digest.more": "de plus",
    "digest.title": "Résumé du jour",
    "digest.byBriefy": "Préparé par Briefy",
    "digest.appointmentsTitle": "Rendez-vous du jour",
    "digest.noAppointments": "Aucun rendez-vous aujourd’hui",
    "digest.tasksTitle": "Tâches du jour",
    "digest.noTasks": "Aucune tâche en attente aujourd’hui",
    "digest.stockTitle": "Stock faible",
    "digest.noLowStock": "Stock suffisant",
    "digest.units": "unités",
    "digest.inactiveTitle": "Clients qui ne sont pas revenus",
    "digest.noInactive": "Tous vos clients sont actifs",
    "digest.waComeback": "Bonjour ! Vous nous manquez 😊 Souhaitez-vous planifier votre prochaine visite ?",
    "digest.draftMsg": "Demander un message à BRIEFY",
    "onboarding.pickIndustryHint": "Choisissez un type d’entreprise pour continuer",
    "analysis.comparative": "Comparatif",
    "analysis.profitability": "Rentabilité",
    "analysis.projections": "Projections",
    "analysis.subtitle": "Comparaisons, rentabilité et projections financières",
    "analysis.help": "Comparez les périodes, analysez la rentabilité par produit et projetez les finances de votre entreprise. Utilisez les onglets pour changer de vue.",
    "analysis.comparativeIntro": "Comparez vos résultats entre les périodes.",
    "analysis.profitabilityIntro": "Identifiez les produits qui contribuent le plus à votre entreprise.",
    "analysis.projectionsIntro": "Explorez l’évolution prévue de vos revenus.",
    "appointments.noAppointments": "Aucun rendez-vous",
    "design.formSubtitle.AppointmentsPage": "Préparez les détails et l’horaire du rendez-vous.",
    "design.formSubtitle.BillsPage": "Organisez vos paiements, dates et rappels.",
    "common.subtotal": "Sous-total",
    "design.removeItem": "Supprimer l’élément",
    "briefy.hintCashflow": "J’analyse votre trésorerie et vous alerte si vos dépenses augmentent plus vite que vos revenus.",
    "companies.noCompanies": "Aucune entreprise enregistrée",
    "common.selectAll": "Tout sélectionner",
    "design.formSubtitle.ContactsPage": "Organisez les informations et le suivi de vos contacts.",
    "contacts.importMobile": "Importer depuis Telephone",
    "briefy.hintCustomers": "Posez-moi des questions sur vos clients : je peux en créer un, planifier un suivi ou rédiger un message.",
    "nav.prospects": "Prospects",
    "customers.visits": "visites",
    "briefy.aboutClient": "Parler à BRIEFY de ce client",
    "customers.history": "Historique du client",
    "customers.totalSpent": "Total dépensé",
    "customers.purchases": "Achats",
    "customers.noPurchases": "Aucun achat enregistré",
    "customers.items": "articles",
    "customers.appointmentsLabel": "Rendez-vous",
    "customers.noAppointments": "Aucun rendez-vous enregistré",
    "briefy.hintInvoices": "Je vous aide à créer des factures et à suivre celles qui restent impayées.",
    "facturas.workspaceTitle": "Factures",
    "facturas.workspaceSubtitle": "Créez des factures, numérisez des justificatifs et consultez vos documents.",
    "invoices.newInvoice": "Nouvelle facture",
    "common.previousMonth": "Mois précédent",
    "common.nextMonth": "Mois suivant",
    "design.formSubtitle.FacturasPage": "Vérifiez les informations, postes et montants de votre facture.",
    "briefy.hintInventory": "Stock faible ? Je peux vous indiquer quels produits réapprovisionner et vous aider à créer des commandes.",
    "inventory.catalogVisible": "Visible dans le catalogue public",
    "notes.confirmDelete": "Supprimer cette note ?",
    "notes.title": "Mes Notes",
    "notes.subtitle": "Notes vocales et dictées enregistrées par Briefy. Votre carnet intelligent.",
    "notes.searchPlaceholder": "Rechercher dans mes notes...",
    "notes.new": "Nouvelle note",
    "notes.newTitle": "Nouvelle note",
    "notes.tip": "Ouvrez Briefy avec le bouton flottant et demandez-lui de noter une liste ou des montants. Briefy peut enregistrer votre note ici.",
    "notes.emptyTitle": "Aucune note pour le moment",
    "notes.empty": "Dictez à Briefy ou créez une note manuellement avec le bouton Nouvelle note.",
    "notes.unpin": "Détacher",
    "notes.pin": "Épingler",
    "notes.dictated": "Dicté par Briefy",
    "notes.titlePlaceholder": "Titre de la note",
    "notes.contentPlaceholder": "Écrivez ou utilisez le microphone pour dicter...",
    "notes.stopDictation": "Arrêter",
    "notes.startDictation": "Dicter",
    "notes.tagsPlaceholder": "Étiquettes (séparées par des virgules)",
    "notes.listening": "À l’écoute... parlez clairement. Touchez le microphone pour arrêter.",
    "notes.editTitle": "Modifier la note",
    "pos.cashIncomeInvalidAmount": "Veuillez saisir un montant valide",
    "pos.cashIncomeDefaultDesc": "Recette manuelle en espèces",
    "pos.cashIncomeSaved": "Recette enregistrée",
    "pos.cashIncomeError": "Impossible d’enregistrer la recette",
    "briefy.hintPos": "Besoin d’aide pour une vente ? Demandez-moi d’ajouter des produits, d’appliquer des remises ou d’enregistrer le paiement.",
    "pos.cashIncome": "Revenus en Espèces",
    "pos.closeCash": "Clôturer la caisse",
    "common.clearSearch": "Effacer la recherche",
    "pos.emptyIndustryTitle": "Votre catalogue est vide",
    "pos.emptyIndustryDesc": "Ajoutez les produits ou services de votre entreprise",
    "pos.goInventory": "Aller à l’inventaire",
    "pos.noCustomer": "Client occasionnel (non enregistré)",
    "pos.cashIncomeSubtitle": "Enregistrez les recettes hors caisse, comme les pourboires, ventes externes ou remboursements d’avances.",
    "pos.todayBalance": "Solde du jour",
    "pos.sales": "Ventes",
    "pos.income": "Gains",
    "pos.expenses": "Depenses",
    "pos.expectedCash": "Espèces attendues",
    "pos.preview": "(aperçu)",
    "pos.amount": "Montant",
    "pos.concept": "Catégorie",
    "pos.conceptExtraSale": "Vente supplémentaire (sans facture)",
    "pos.conceptTip": "Pourboire",
    "pos.conceptCommission": "Commission",
    "pos.conceptRent": "Loyer perçu",
    "pos.conceptRefund": "Remboursement reçu",
    "pos.conceptOther": "Autres recettes",
    "pos.description": "Description",
    "pos.descriptionPlaceholder": "Détails de la recette (facultatif)...",
    "briefy.hintPayroll": "Je vous aide à calculer les rémunérations et retenues et à préparer la paie de votre équipe.",
    "clock.tabLabel": "Pointeuse",
    "tasks.tabLabel": "Tâches",
    "ui.kioskPin": "Code PIN de la pointeuse",
    "ui.optional4digits": "4 chiffres, facultatif",
    "ui.kioskPinHint": "L’employé utilisera ce code PIN pour pointer son entrée et sa sortie.",
    "pricing.subscribe": "S’abonner",
    "briefy.hintPurchases": "Besoin de réapprovisionner ? Je vous aide à créer des commandes pour vos fournisseurs.",
    "design.formSubtitle.PurchasesPage": "Vérifiez le fournisseur et les détails de l’achat.",
    "design.formSubtitle.RealEstatePage": "Organisez les informations de vos biens et clients.",
    "design.formSubtitle.documents": "Enregistrez et organisez les documents de ce client.",
    "settings.taxConfig": "Paramètres fiscaux",
    "settings.selectRegion": "Sélectionnez votre région",
    "settings.taxRatePct": "Taux de taxe (%)",
    "settings.taxNameLabel": "Nom de la taxe",
    "settings.invoicePreview": "Aperçu de la facture :",
    "settings.previewBase": "Sur une vente de 100 $",
    "settings.accountInfo": "Informations du compte",
    "settings.plan": "Forfait",
    "settings.planBusiness": "Entreprise",
    "settings.planFree": "Gratuit",
    "settings.subSuccess": "Abonnement réussi !",
    "settings.subSuccessDesc": "Votre forfait a été mis à jour. Profitez de toutes les fonctionnalités.",
    "briefy.hintTasks": "Dites-moi ce que vous devez faire et je l’ajouterai à votre liste de tâches avec un rappel.",
    "briefy.hintTransport": "Posez-moi des questions sur l’entretien, les dépenses ou les documents de vos véhicules.",
    "ui.noData": "Aucune donnée",
    "design.formSubtitle.TransportPage": "Tenez à jour vos véhicules et leurs dépenses.",
    "common.next": "Suivant",
    "common.myBusiness": "Mon entreprise",
    "common.preview": "Aperçu",
    "closing.alreadyClosed": "La caisse de ce jour est déjà clôturée",
    "closing.openingBalance": "Solde initial",
    "closing.totalSales": "Total des ventes",
    "closing.actualBalance": "Solde réel",
    "closing.difference": "Écart",
    "closing.closeDay": "Clôturer la journée",
    "closing.totalIncome": "Total des recettes",
    "closing.totalExpenses": "Total des dépenses",
    "closing.expectedBalance": "Solde attendu",
    "closing.notes": "Notes",
    "banners.tools.AdminPage.title": "Administration",
    "banners.tools.AdminPage.subtitle": "Gérez les utilisateurs, forfaits et avis",
    "banners.tools.AdminRevenuePage.title": "Revenus · Administration",
    "banners.tools.AdminRevenuePage.subtitle": "Abonnements et commissions Briefcase Pay",
    "banners.tools.CobrosPage.title": "Paiements Électroniques",
    "banners.tools.CobrosPage.subtitle": "Gérez les paiements par carte et les virements",
    "banners.tools.InventoryPage.subtitle": "Gérez les produits, stocks et codes-barres",
    "banners.tools.ServicesPage.title": "Catalogue de Services",
    "banners.tools.ServicesPage.subtitle": "Organisez, facturez et analysez les services de votre entreprise"
  }
};
